export default __webpack_public_path__ + "static/media/unwillingsacrifice.9958fd17.png";